const CustomViewType = {
    LIST: 'list',
    GRID: 'grid',
};

export { CustomViewType };



// WEBPACK FOOTER //
// ./source/constants/customViews.js